module.exports = __webpack_public_path__ + "static/media/Pan.734cf527.png";